import { render, staticRenderFns } from "./OrderMetadataConfigurator.vue?vue&type=template&id=678533b0"
import script from "./OrderMetadataConfigurator.vue?vue&type=script&lang=js"
export * from "./OrderMetadataConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports